import { useState } from 'react';
import Segmented from '@/components/base/Segmented';
import ProductDiscounts from './components/ProductDiscounts';
import DiscountCodes from './components/DiscountCodes';
import DiscountHistory from './components/DiscountHistory';

type Tab = 'product' | 'cashier' | 'admin' | 'history';

export default function DiscountsPage() {
  const [tab, setTab] = useState<Tab>('product');

  const options = [
    { value: 'product', label: 'Por producto' },
    { value: 'cashier', label: 'Códigos de cajeros' },
    { value: 'admin', label: 'Códigos de administradores' },
    { value: 'history', label: 'Historial' },
  ];

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">Descuentos</h1>
          <p className="mt-1 text-foreground-600">
            Descuentos por producto y códigos de descuento para cajeros y administradores.
          </p>
        </div>
      </div>

      <div className="mt-6 overflow-x-auto">
        <Segmented options={options} value={tab} onChange={(v) => setTab(v as Tab)} />
      </div>

      <div className="mt-6">
        {tab === 'product' && <ProductDiscounts />}
        {tab === 'cashier' && <DiscountCodes scope="cashier" />}
        {tab === 'admin' && <DiscountCodes scope="admin" />}
        {tab === 'history' && <DiscountHistory />}
      </div>
    </div>
  );
}